import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalTooltip, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';

@Component({
  selector: 'sd-cart-share-tooltip',
  imports: [SdvorIconComponent],
  templateUrl: './cart-share-tooltip.component.html',
  styleUrls: ['./cart-share-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartShareTooltipComponent {
  private readonly modalTooltip = inject(ModalTooltip);

  protected readonly iconTypes = IconTypes;

  close(): void {
    this.modalTooltip.close();
  }
}
